import React, { Component } from 'react';
import BaseInput from '../BaseInput/BaseInput';

export default class TextInput extends Component {
  constructor(props) {
    super(props);
    this.keyPressHandler = this.keyPressHandler.bind(this);
  }
  keyPressHandler(event) {
    const { charPattern } = this.props;
    const { key } = event;
    if (key && !charPattern.test(key)) {
      event.preventDefault();
    }
  }
  render() {
    const { charPattern, ...rest } = this.props;
    return (
      <BaseInput
        onKeyPress={charPattern ? this.keyPressHandler : undefined}
        {...rest}
      />
    );
  }
}
